import { LocalItem } from '~Types';
import { checkOutOfStock } from './inventory';
import { Item } from '@baemingo/inventory-events/dist/types';

export const checkCartItemsAvailability = (cartItems: LocalItem[], inventoryItems: Item[]) => {
  const cartItemsReversed = [...cartItems].reverse();
  const availableItems = [...cartItemsReversed];
  const unavailableItems: LocalItem[] = [];
  let hasOutOfStock = false;

  const removeItem = (id: string) => {
    hasOutOfStock = true;
    const index = availableItems.findIndex((a) => a.itemId === id);
    if (index !== -1) {
      const removed = availableItems.splice(index, 1);
      unavailableItems.push(removed[0]);
    }
  };

  cartItemsReversed.forEach((item) => {
    // Check Item
    const isOutOfStock = checkOutOfStock({
      id: item.itemId,
      inventoryItems,
      disregardCount: false,
      cartItems: availableItems,
      isCart: true,
    });

    if (isOutOfStock) {
      removeItem(item.itemId);
    } else {
      // Check Item variations
      for (const variation of item.variations) {
        const isOutOfStock = checkOutOfStock({
          id: variation.id,
          inventoryItems,
          disregardCount: true,
        });

        if (isOutOfStock) {
          removeItem(item.itemId);

          break;
        }
      }
    }
  });

  availableItems.reverse();
  unavailableItems.reverse();

  return { hasOutOfStock, availableItems, unavailableItems };
};
